import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { RouletteNumberDisplay } from '../../../models/roulette.model';
import { RouletteHistoryService } from '../../../services/roulette-history.service';
import { RouletteService } from '../../../services/roulette.service';

@Component({
    selector: 'app-roulette-history',
    standalone: true,
    imports: [],
    templateUrl: './roulette-history.component.html',
    styleUrls: ['./roulette-history.component.scss']
})
export class RouletteHistoryComponent implements OnInit {
    displayedHistory: RouletteNumberDisplay[] = [];
    private readonly maxHistoryDisplay = 13;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private readonly roulette: RouletteService,
        private readonly historyService: RouletteHistoryService
    ) {}

    ngOnInit(): void {
        this.historyService
            .getHistory$()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((history) => {
                this.updateDisplayedHistory(history);
            });
    }

    private updateDisplayedHistory(history: number[]): void {
        this.displayedHistory = history
            .slice(-this.maxHistoryDisplay)
            .reverse()
            .map((number) => ({
                value: number,
                displayValue: this.roulette.getDisplayValue(number),
                backgroundClass: this.roulette.getBackgroundColorClass(number)
            }));
    }
}
